export enum TicketStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_STORE = 'WAITING_STORE',
  RESOLVED = 'RESOLVED',
}

export enum TicketSla {
  HOURS_8 = 'HOURS_8',
  HOURS_24 = 'HOURS_24',
  HOURS_48 = 'HOURS_48',
}

export enum TicketEventKind {
  OPENED = 'OPENED',
  AUTO_REPLY = 'AUTO_REPLY',
  ASSIGNED = 'ASSIGNED',
  MESSAGE = 'MESSAGE',
  RESOLVED = 'RESOLVED',
  STATUS_CHANGED = 'STATUS_CHANGED',
}

export enum TicketListTab {
  OPEN = 'OPEN',
  WAITING = 'WAITING',
  RESOLVED = 'RESOLVED',
  ALL = 'ALL',
}

export enum TicketDueFilter {
  LATE = 'LATE',
  RESOLVED_ON_TIME = 'RESOLVED_ON_TIME',
  RESOLVED_LATE = 'RESOLVED_LATE',
}

export type TicketListFilterValues = {
  department?: string;
  store?: string;
  due?: TicketDueFilter;
};

export enum TicketComposerStep {
  SUBJECT = 'SUBJECT',
  DETAILS = 'DETAILS',
}

export enum TicketFormFieldType {
  OPTIONS = 'OPTIONS',
  MONEY = 'MONEY',
  QUANTITY = 'QUANTITY',
  DATE = 'DATE',
  UPLOAD = 'UPLOAD',
  YES_NO = 'YES_NO',
}

export type TicketFormField = {
  label: string;
  type: TicketFormFieldType;
  required: boolean;
  showInTitle: boolean;
  help?: string;
  options?: string[];
};

export type TicketSubject = {
  id: string;
  name: string;
  hint: string;
  sla: TicketSla;
  form: TicketFormField[];
  instruction?: string;
};

export type TicketCategory = { id: string; name: string; subjects: TicketSubject[] };

export type TicketDepartment = { id: string; name: string; categories: TicketCategory[] };

export type TicketSubjectPath = { subjectId: string; department: string; category: string; subject: string };

export type TicketFieldValue = { label: string; value: string };

export type TicketSlaDeadline = { sla: TicketSla; dueAt: string };

export type TicketEvent = {
  id: string;
  kind: TicketEventKind;
  author: string;
  role: string;
  mine: boolean;
  at: string;
  text: string;
  attachments: string[];
  status?: TicketStatus;
};

export type Ticket = {
  id: string;
  number: number;
  title: string;
  status: TicketStatus;
  path: TicketSubjectPath;
  sla: TicketSla;
  dueLabel: string;
  dueAt: string;
  late: boolean;
  resolvedOnTime?: boolean;
  resolutionTimeLabel?: string;
  store: string;
  requester: string;
  assignee?: string;
  openedAt: string;
  origin: string;
  relatedTicketNumber?: number;
  fields: TicketFieldValue[];
  events: TicketEvent[];
  lastUpdate: string;
  lastUpdateAt: string;
};

export type TicketOpenInput = {
  subjectId: string;
  store: string;
  description: string;
  fields: TicketFieldValue[];
  attachments: string[];
  origin: string;
  requester: string;
  relatedTicketNumber?: number;
  conversation?: string;
};

export type TicketOpenedHandler = (ticket: Ticket) => void;

export type TicketPrefill = {
  subjectId?: string;
  description?: string;
  fields?: TicketFieldValue[];
  relatedTicketNumber?: number;
  conversation?: string;
  conversationLabel?: string;
};

export type TicketDetailsValues = {
  store: string;
  fields: TicketFieldValue[];
  description: string;
  attachments: string[];
};
